<template>
    <v-container fluid>
        <v-row class="align-center pl-3">
            <!-- Breadcrumbs -->
            <v-breadcrumbs
                :items="[
                    { text: 'Home', disable: false, href: '/#/' },
                    { text: 'Groups', disabled: true }
                ]"
                divider="/"
            ></v-breadcrumbs>
            <v-spacer />
        </v-row>

        <!-- New Group Dialog-->
        <TenantUserGroupEditDialog
            :dialog.sync="newTenantUserGroupDialog"
            v-on:item-created="onTenantUserGroupCreated"
        ></TenantUserGroupEditDialog>

        <v-row class="ma-0">
            <v-col cols="12" class="pt-0">
                <v-hover>
                    <template v-slot="{ hover }">
                        <v-card :elevation="hover ? 6 : 1">
                            <!-- Header -->
                            <v-card-title class="pb-0">
                                <v-icon color="primary" class="mx-2"
                                    >people_outline</v-icon
                                >Groups
                                <v-spacer></v-spacer>
                                <v-btn
                                    color="primary"
                                    dark
                                    outlined
                                    rounded
                                    small
                                    @click="newTenantUserGroupDialog = true"
                                    >New Group</v-btn
                                >
                                <!-- <v-speed-dial
                                    direction="left"
                                    transition="slide-x-reverse-transition"
                                >
                                    <template v-slot:activator>
                                        <v-btn small text fab>
                                            <v-icon>more_vert</v-icon>
                                        </v-btn>
                                    </template>
                                    <v-btn
                                        color="primary"
                                        dark
                                        fab
                                        x-small
                                        @click="newProductDialog=true"
                                    >
                                        <v-icon>add</v-icon>
                                    </v-btn>
                                </v-speed-dial>-->
                            </v-card-title>

                            <!-- Group table -->
                            <v-container fluid>
                                <v-data-table
                                    :headers="headers"
                                    :loading="
                                        $apollo.queries.tenantUserGroups.loading
                                    "
                                    :items="tenantUserGroups.edges"
                                    :itemsPerPage="itemsPerPage"
                                    :footer-props="{
                                        'items-per-page-options': [
                                            10,
                                            25,
                                            50,
                                            75,
                                            100
                                        ]
                                    }"
                                    sortBy="node.name"
                                    loading-text="Loading... Please wait"
                                >
                                    <template
                                        v-slot:item.node.group.userSet.totalCount="{
                                            item
                                        }"
                                    >
                                        <span
                                            v-if="
                                                item.node.group.userSet
                                                    .totalCount == 0
                                            "
                                            class="error--text"
                                            >{{
                                                item.node.group.userSet
                                                    .totalCount
                                            }}</span
                                        >
                                        <span v-else>{{
                                            item.node.group.userSet.totalCount
                                        }}</span>
                                    </template>
                                    <template v-slot:item.action="{ item }">
                                        <v-btn
                                            icon
                                            color="primary"
                                            @click="
                                                goToTenantUserGroupDetail(
                                                    item.node.id
                                                )
                                            "
                                        >
                                            <v-icon>visibility</v-icon>
                                        </v-btn>
                                        <!-- <v-icon small @click="deletingProduct(item)">delete</v-icon> -->
                                    </template>
                                </v-data-table>
                            </v-container>
                        </v-card>
                    </template>
                </v-hover>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import gql from "graphql-tag";
import TenantUserGroupEditDialog from "@/components/tenants/TenantUserGroupEditDialog.vue";

export default {
    name: "tenant-user-group-list-page",
    components: {
        TenantUserGroupEditDialog
        // DeleteDialog
    },

    apollo: {
        tenantUserGroups: {
            query: gql`
                query tenantUserGroups(
                    $first: Int
                    $last: Int
                    $before: String
                    $after: String
                ) {
                    tenantUserGroups(
                        first: $first
                        last: $last
                        before: $before
                        after: $after
                    ) {
                        edgeCount
                        totalCount
                        pageInfo {
                            startCursor
                            endCursor
                            hasPreviousPage
                            hasNextPage
                        }
                        edges {
                            node {
                                id
                                name
                                group {
                                    id
                                    userSet {
                                        totalCount
                                    }
                                }
                            }
                        }
                    }
                }
            `,
            variables() {
                return {};
            },
            // Additional options here
            fetchPolicy: "cache-and-network",
            update: (data) => data.tenantUserGroups,
            // skip: true,
            pollInterval: 60000 // ms
        }
    },

    data: function () {
        return {
            newTenantUserGroupDialog: false,

            selectedProductNodeId: null,

            tenantUserGroups: {},

            itemsPerPage: 25,
            search: "",

            headers: [
                {
                    text: "Group",
                    value: "node.name",
                    sortable: true
                },
                {
                    text: "#Users",
                    value: "node.group.userSet.totalCount",
                    sortable: true
                },
                {
                    text: "Actions",
                    value: "action",
                    width: "120px",
                    align: "center",
                    sortable: false
                }
            ],
            editedIndex: -1
        };
    },
    computed: {},
    watch: {},
    created() {},
    mounted() {},
    methods: {
        onTenantUserGroupCreated() {
            this.newTenantUserGroupDialog = false;
            this.$apollo.queries.tenantUserGroups.refresh();
        },

        goToTenantUserGroupDetail(tenantUserGroupNodeId) {
            // let routeData = this.$router.resolve({
            //     name: "group-detail",
            //     params: { id: tenantUserGroupNodeId }
            // });
            // window.open(routeData.href, "_blank");

            this.$router.push("/group/" + tenantUserGroupNodeId);
        }
    }
};
</script>